import { Typography, RadioGroup, RadioGroupItem, Label } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";
import { Control, Controller } from "react-hook-form";
import { cn } from "@/lib/utils";
import type { SubscriptionFormData } from "@/pages/subscriptions/services/types";

interface SubscriptionTypeSelectorProps {
  control: Control<SubscriptionFormData>;
  isEditMode: boolean;
}

const SubscriptionTypeSelector = ({ control, isEditMode }: SubscriptionTypeSelectorProps) => {
  return (
    <div>
      <Typography variant="body" weight="medium" className="al-mb-4">
        Subscription Type <span className="al-text-red-600">*</span>
      </Typography>
      <Controller
        name="rule_type"
        control={control}
        render={({ field }) => (
          <RadioGroup
            value={field.value}
            onValueChange={isEditMode ? undefined : field.onChange}
            disabled={isEditMode}
          >
            <div className="al-grid al-grid-cols-2 al-gap-4">
              <Label
                htmlFor="report"
                className={cn(
                  "al-border al-rounded-lg al-p-4 al-transition-all al-block al-font-normal",
                  isEditMode ? "al-cursor-not-allowed al-opacity-60" : "al-cursor-pointer",
                  field.value === "report"
                    ? "al-border-blue-500 al-from-background al-bg-gradient-to-tr al-via-background al-to-blue-100"
                    : "al-border-gray-200 hover:al-border-gray-300"
                )}
              >
                <Stack direction="row" gap="md" className="al-items-start">
                  <RadioGroupItem
                    value="report"
                    id="report"
                    className="al-mt-1"
                    disabled={isEditMode}
                  />
                  <div className="al-flex-1">
                    <span
                      className={cn(
                        "al-font-semibold al-text-base",
                        isEditMode ? "al-cursor-not-allowed" : "al-cursor-pointer"
                      )}
                    >
                      Report
                    </span>
                    <Typography variant="body" size="xs" className="al-text-gray-600 al-mt-1 al-block">
                      Periodic updates regarding your selected entity
                    </Typography>
                  </div>
                </Stack>
              </Label>
              <Label
                htmlFor="alert"
                className={cn(
                  "al-border al-rounded-lg al-p-4 al-transition-all al-block al-font-normal",
                  isEditMode ? "al-cursor-not-allowed al-opacity-60" : "al-cursor-pointer",
                  field.value === "alert"
                    ? "al-border-blue-500 al-from-background al-bg-gradient-to-tr al-via-background al-to-blue-100"
                    : "al-border-gray-200 hover:al-border-gray-300"
                )}
              >
                <Stack direction="row" gap="md" className="al-items-start">
                  <RadioGroupItem
                    value="alert"
                    id="alert"
                    className="al-mt-1"
                    disabled={isEditMode}
                  />
                  <div className="al-flex-1">
                    <span
                      className={cn(
                        "al-font-semibold al-text-base",
                        isEditMode ? "al-cursor-not-allowed" : "al-cursor-pointer"
                      )}
                    >
                      Alert
                    </span>
                    <Typography variant="body" size="xs" className="al-text-gray-600 al-mt-1 al-block">
                      Send updates only when certain triggers are met
                    </Typography>
                  </div>
                </Stack>
              </Label>
            </div>
          </RadioGroup>
        )}
      />
    </div>
  );
};

export default SubscriptionTypeSelector;
